import { useMemo } from 'react';

export const useWholeHoursInRange = (start: Date, end: Date, max: number) => {
	const wholeHoursInRange = useMemo(() => {
		const hoursInRange: { hour: Date; hoursFromReference: number }[] = [];
		const hourMs = 60 * 60 * 1000; // 1 hour in milliseconds

		let currHour = new Date(Math.ceil(start.getTime() / hourMs) * hourMs);
		while (currHour < end && hoursInRange.length <= max - 1) {
			const hoursFromReference = (currHour.getTime() - start.getTime()) / hourMs;
			hoursInRange.push({ hour: currHour, hoursFromReference: hoursFromReference });
			currHour = new Date(currHour.getTime() + hourMs);
		}

		return hoursInRange;
	}, [start, end]);

	return wholeHoursInRange;
};
